import React from 'react';
import { Grid } from '@mui/material';
import CancelShipment from './CancelOrder';
import RepeatOrder from './RepeatOrder';
import { userLogin } from '@Services/hasAdminAccess';

interface PropsType {
  shipmentStatus: string;
  accountId?: string;
  isInTransit?: boolean;
}

function CancelAndTrackShipment({ shipmentStatus, accountId, isInTransit }: PropsType) {
  const isUserLogin = userLogin();
  return (
    <Grid item display={'flex'}>
      {isUserLogin ? (
        <div>{shipmentStatus === 'placed' && !isInTransit && <CancelShipment />}</div>
      ) : (
        <div>
          {(shipmentStatus === 'placed' || shipmentStatus === 'forwarded' || shipmentStatus === 'at_warehouse') &&
            !isInTransit && <CancelShipment />}
        </div>
      )}
      <div>{<RepeatOrder accountId={accountId} />}</div>
    </Grid>
  );
}

export default CancelAndTrackShipment;
